import { lengthBetween } from 'utils/validation-utils'
import { action, observable, makeObservable } from 'mobx'
import { v4 } from 'uuid'
import { required, validationContext } from 'validx'

/**
 * View Model for each Document Upload Item.
 */
export default class DocumentUploadItemViewModel {
  /**
   * Holds the maximum lengths for each field.
   */
  private readonly fieldLengths = {
    title: { min: 1, max: 100 },
  } as const

  /**
   * Identifier for this view model.
   */
  private readonly _id = v4()

  /**
   * The title of the document upload item.
   */
  @observable
  title = ''

  /**
   * Validation context for this view model.
   */
  validation = validationContext(this, {
    title: [
      required('A document title is required.'),
      lengthBetween(
        this.fieldLengths.title.min,
        this.fieldLengths.title.max,
        `A document title must be between ${this.fieldLengths.title.min} and ${this.fieldLengths.title.max} characters.`,
      ),
    ],
  })

  constructor() {
    makeObservable(this)
  }

  /**
   * Validates the view model.
   */
  @action.bound
  validate() {
    return this.validation.reset().validate().isValid
  }

  /**
   * The identifier for the view model.
   */
  get id() {
    return this._id
  }
}
